import { fetchWhatsappConversations } from "../services/Whatsapp.service";

export const FETCH_CONVERSATIONS_REQUEST = "FETCH_CONVERSATIONS_REQUEST";
export const FETCH_CONVERSATIONS_SUCCESS = "FETCH_CONVERSATIONS_SUCCESS";
export const FETCH_CONVERSATIONS_FAILURE = "FETCH_CONVERSATIONS_FAILURE";
export const UPSERT_CONVERSATION_AT_TOP = "UPSERT_CONVERSATION_AT_TOP";

export const fetchConversations = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CONVERSATIONS_REQUEST });
    const res = await fetchWhatsappConversations(params);
    const newData = res?.data?.data || [];
    const totalCount = res?.data?.totalCount || 0;
    
    dispatch({
      type: FETCH_CONVERSATIONS_SUCCESS,
      payload: {
        conversations: newData,
        totalCount: totalCount,
        currentPage: params?.page || 1,
        hasMoreData: newData.length > 0, // Track if this page had data
      },
    });
  } catch (error) {
    dispatch({
      type: FETCH_CONVERSATIONS_FAILURE,
      payload: error?.message || "Something went wrong",
    });
  }
};
export const upsertConversationAtTop = (conversation) => ({
  type: UPSERT_CONVERSATION_AT_TOP,
  payload: conversation,
});
